import { render, staticRenderFns } from "./CoursePrice.vue?vue&type=template&id=e42165b4"
import script from "./CoursePrice.vue?vue&type=script&lang=js"
export * from "./CoursePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports